<template>
  <div class="productGrid">
    <product-tile
      v-for="product in products.slice(0, 5)"
      :key="product.id"
      :product="product"
      class="productGrid__tile"
      :list-name="listName"
    />
    <!--    <newsletter-grid v-if="!subscribedToNewsletter" />-->
    <search-encouragement-grid v-if="!isLogged" />
    <product-tile
      v-for="product in products.slice(5, products.length)"
      :key="product.id"
      :product="product"
      class="productGrid__tile"
      :list-name="listName"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductTile from './ProductTile';
// import NewsletterGrid from '~/components/Newsletter/NewsletterGrid';
import SearchEncouragementGrid from '@/components/Search/SearchEncouragementGrid';

export default {
  name: 'ProductGrid',
  components: {
    SearchEncouragementGrid,
    ProductTile,
    // NewsletterGrid,
  },
  props: {
    products: {
      type: Array,
      default: () => {},
    },
    listName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('auth', ['subscribedToNewsletter', 'isLogged']),
  },
};
</script>

<style lang="scss">
.productGrid {
  $root: &;
  display: flex;
  flex-wrap: wrap;
  margin-left: -8px;
  margin-right: -8px;

  &__tile {
    flex: 0 0 33.333%;
    max-width: 33.333%;
    margin-bottom: 16px;
    padding-left: 8px;
    padding-right: 8px;
    height: auto;

    @include rwd('laptop') {
      flex: 0 0 50%;
      max-width: 50%;
    }

    @include rwd('small-tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}
</style>
